/**
 * Content Library — tab registry.
 *
 * The Content Library shell is a generic host; each game-type module that has
 * reusable content registers a tab here. Adding a new game's asset module is a
 * one-line addition to this array (plus its provider in ContentLibraryProviders)
 * — the shell renders whatever is registered.
 */

import type { ComponentType } from 'react';
import { TrlImageLibraryTab } from './trailblazers';

export interface ContentLibraryTab {
  /** Stable tab id. */
  id: string;
  /** Tab label shown in the navigation. */
  label: string;
  /** Body component rendered when the tab is active. */
  Component: ComponentType;
}

export const CONTENT_LIBRARY_TABS: ContentLibraryTab[] = [
  { id: 'trailblazers', label: 'Trailblazers', Component: TrlImageLibraryTab },
];
